import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getDisableBYDeliveryDateFlag } from 'yoda-site-components/lib/selectors/byDeliveryDateSelector';

const getBundleItemOffering = (state) => state.bundleItemOffering;

/* istanbul ignore next */
const formatDateAsMMDDYYYY = (date) => {
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

/* istanbul ignore next */
const getBundleProductDeliveryDate = createSelector(
    [getBundleItemOffering, getDisableBYDeliveryDateFlag],
    (bundleItemOffering = {}, byDeliveryDateFlag = false) => {
        const inventoryData = Object.keys(bundleItemOffering);
        let bundleDeliveryDateForAnalytics = {};
        if (inventoryData.length) {
            inventoryData.forEach((ppid) => {
                if (_get(bundleItemOffering, [ppid, 'promise'])) {
                    const serviceLevels = _get(
                        bundleItemOffering[ppid].promise,
                        'skuDeliveryOptions[0].deliveryOptions.shipToHome.serviceLevels[0]',
                        {}
                    );
                    const deliveryDate = _get(serviceLevels, 'deliveryDate', '');
                    const deliveryDateForAnalytics =
                        !byDeliveryDateFlag && serviceLevels
                            ? formatDateAsMMDDYYYY(new Date(deliveryDate))
                            : formatDateAsMMDDYYYY(new Date(serviceLevels.deliveryDateEnd)) || '';

                    bundleDeliveryDateForAnalytics = {
                        ...bundleDeliveryDateForAnalytics,
                        [ppid]: {
                            deliveryDateForAnalytics,
                        },
                    };
                }
            });
        }
        return bundleDeliveryDateForAnalytics;
    }
);

export default getBundleProductDeliveryDate;
